import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/menu")({
	loader: () => {
		throw redirect({ href: "/menu.pdf", statusCode: 301 });
	},
});
